module.exports = __webpack_public_path__ + "img/antes_despues_07.7a8cdbce.png";